import React, { useContext, useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'

const AuthContext = React.createContext()

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const session = supabase.auth.getSession()

    setUser(session?.user ?? null)
    setLoading(false)

    const { data: listener } = supabase.auth.onAuthStateChange(
      async (event, session) => {
        setUser(session?.user ?? null)
        setLoading(false)
      }
    )

    return () => {
      //listener?.unsubscribe()
    }
  }, [])
    const fakeSignIn = async ({username, company}) => {
      const fakeUser = {
        id: username,
        aud: 'authenticated',
        role: 'authenticated',
        email: `${username}`,
        email_confirmed_at: new Date().toISOString(),
        phone: '',
        confirmed_at: new Date().toISOString(),
        last_sign_in_at: new Date().toISOString(),
        app_metadata: {
          provider: 'email',
          providers: ['email'],
        },
        user_metadata: {
          username: username,
        },
        identities: [],
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      }

      // Try to sign in the user first
      const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({
        email: fakeUser.email,
        password: 'password123',
      })
      console.log('signInData:', signInError)
      if (!signInError) {
        setUser(signInData.user)
        return Promise.resolve({ data: { user: signInData.user }, error: null })
      }

      // If sign in fails, try to sign up the user
      const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
        email: fakeUser.email,
        password: 'password123', // You might want to generate a random password or get it from user input
      })

      if (signUpError) {
        console.error('Error signing up:', signUpError)
        return Promise.reject({ error: signUpError })
      }

      // Create a new user in the users table only if they don't exist
      const { data: userData, error: userError } = await supabase
        .from('users')
        .upsert([
          {
            id: signUpData.user.id,
            email: fakeUser.email,
            role: 'user',
            name: username,
            company: parseInt(company),
            score: 0,
            avatar: null,
            firebase_token: null
          }
        ], { onConflict: 'id' })
        .select()

      if (userError) {
        console.error('Error creating user record:', userError)
        return Promise.reject({ error: userError })
      }
      

      // Try to sign in again after successful sign up
      const { data: newSignInData, error: newSignInError } = await supabase.auth.signInWithPassword({
        email: fakeUser.email,
        password: 'password123',
      })

      if (newSignInError) {
        console.error('Error signing in after sign up:', newSignInError)
        return Promise.reject({ error: newSignInError })
      }

      setUser(newSignInData.user)
      return Promise.resolve({ data: { user: newSignInData.user }, error: null })
    }

  const value = {
    signUp: (data) => supabase.auth.signUp(data),
    signIn: (data) => supabase.auth.signInWithPassword(data),
    signOut: () => supabase.auth.signOut(),
    fakeSignIn,
    user,
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}